export function IntegerData() {
    return {
        name: "integer",
        label: "Integer",
        primitiveType: "integer",
    };
}

export default IntegerData;
